// Tiny fetch wrapper for the /api backend.
async function req(url, options) {
  const res = await fetch(url, options)
  const isJson = (res.headers.get('content-type') || '').includes('application/json')
  const body = isJson ? await res.json() : null
  if (!res.ok) throw new Error(body?.error || res.statusText || 'Request failed')
  return body
}

const jsonPost = (url, data, method = 'POST') =>
  req(url, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ?? {}),
  })

export const api = {
  // Public
  clients: () => req('/api/clients'),
  impact: () => req('/api/impact'),
  news: () => req('/api/news'),
  article: (slug) => req(`/api/news/${encodeURIComponent(slug)}`),
  contact: (d) => jsonPost('/api/contact', d),

  // Admin auth
  me: () => req('/api/admin/me'),
  login: (password) => jsonPost('/api/admin/login', { password }),
  logout: () => jsonPost('/api/admin/logout', {}),
  changePassword: (currentPassword, newPassword) =>
    jsonPost('/api/admin/password', { currentPassword, newPassword }),

  // Admin: clients
  adminClients: () => req('/api/admin/clients'),
  createClient: (d) => jsonPost('/api/admin/clients', d),
  updateClient: (id, d) => jsonPost(`/api/admin/clients/${id}`, d, 'PUT'),
  deleteClient: (id) => req(`/api/admin/clients/${id}`, { method: 'DELETE' }),

  // Admin: news
  adminNews: () => req('/api/admin/news'),
  createArticle: (d) => jsonPost('/api/admin/news', d),
  updateArticle: (id, d) => jsonPost(`/api/admin/news/${id}`, d, 'PUT'),
  deleteArticle: (id) => req(`/api/admin/news/${id}`, { method: 'DELETE' }),

  // Admin: impact + uploads
  saveImpact: (d) => jsonPost('/api/admin/impact', d, 'PUT'),
  upload: (dataUrl, prefix) => jsonPost('/api/admin/upload', { dataUrl, prefix }),

  // Admin: contact-messages inbox
  adminMessages: () => req('/api/admin/messages'),
  setMessageRead: (id, read) => jsonPost(`/api/admin/messages/${id}`, { read }, 'PUT'),
  deleteMessage: (id) => req(`/api/admin/messages/${id}`, { method: 'DELETE' }),

  // Admin: quotations
  adminQuotes: () => req('/api/admin/quotes'),
  quote: (id) => req(`/api/admin/quotes/${id}`),
  createQuote: (d) => jsonPost('/api/admin/quotes', d),
  updateQuote: (id, d) => jsonPost(`/api/admin/quotes/${id}`, d, 'PUT'),
  setQuoteStatus: (id, status) => jsonPost(`/api/admin/quotes/${id}`, { status }, 'PUT'),
  deleteQuote: (id) => req(`/api/admin/quotes/${id}`, { method: 'DELETE' }),
  quoteSettings: () => req('/api/admin/quote-settings'),
  saveQuoteSettings: (d) => jsonPost('/api/admin/quote-settings', d, 'PUT'),
}
